import BaseService from '../BaseService'
import axios from "axios";

class UserService extends BaseService {
    constructor() {
        super('/users');
    }

    updatePassword({payload}) {
        return axios.put(`${this.resource}/update-password`, payload)
    }

    updateAvatar({payload}) {
        return axios.post(`${this.resource}/update-avatar`, payload)
    }

    cancelSubscription() {
        return axios.post(`api/v1/user/cancel-subscription`)
    }

    resumeSubscription() {
        return axios.post(`api/v1/user/resume-subscription`)
    }

    setUserStatus() {
        return axios.post(`${this.resource}/set-user-status?notificationOff`)
    }

    getUserSubscriptionQuota() {
        return axios.get(`api/v1/user/subscription-quota`)
    }

    billingPortal({payload}) {
        return axios.post(`api/v1/user/billing-portal?notificationOff`, payload)
    }

    choose({payload}) {
        return axios.post(`api/v1/user/choose-subscription?notificationOff`, payload)
    }
}

export default new UserService()
